import {meijuFrom,meijuFromkey} from '../../js/meijuForm'
import {formDate,formYearMonth} from '../utils/modules/formDate.js'
import formMoney from '../utils/modules/formMoney.js'
import filterZjhm from '../utils/modules/filterZjhm'
import filterSjhm from '../utils/modules/filterSjhm'
import filterYhkh from '../utils/modules/filterYhkh.js'


// 枚举过滤器
let filterMeiju = meijuFrom;
let filterMeijuKey =meijuFromkey;

//日期过滤器
let filterDate = formDate;

let filterYearMonth = formYearMonth;

//人民币格式化
let filterMoney = formMoney;

export {
  filterMeiju,
  filterDate,
  filterMoney,
  filterYearMonth,
    filterMeijuKey,
    filterZjhm,
    filterSjhm,
    filterYhkh,
}



// WEBPACK FOOTER //
// ./src/static/js/filters/index.js